export default __webpack_public_path__ + "static/media/affligem_xl1.5389b6ad.png";